import { type BotConfig } from "./src/config";

export const botConfigs: BotConfig[] = [
  {
    name: "sailfish-sol",
    chain: "solana",
    api: "",
    ws: "",
    raven_api: "",
    sailfish_api: "https://sailfish.0xfire.com",
    sailfish_ws: "wss://sailfish.0xfire.com/stream/public/ws",
    wallet: "WALLET",
    color: "purple",
    dexscreener: "https://dexscreener.com/solana",
    explorer: "https://solscan.io",
  },
];
